import { useState } from 'react';
import Card from 'components/atoms/Card';
import Icon from 'components/atoms/Icon';
import Typography from 'components/atoms/Typography';
import Select from 'components/molecules/Select';
import Input from 'components/molecules/Input';
import Button from 'components/atoms/Button';

import { PlaybookResource } from 'utils/gloo-types';
import { getUUID } from 'utils/common';
import CloudinaryImageUploader from 'components/organisms/CloudinaryImageUpload';

// TODO: Deprecate this component once enableDiscoverRedesign goes live

interface PlaybookResourcesListProps {
  handleSelected: (resources) => void;
  resources: PlaybookResource[];
}

function PlaybookResourcesList({ resources, handleSelected }: PlaybookResourcesListProps) {
  const [newResource, setNewResource] = useState<PlaybookResource>();

  const resourceTypes = [
    {
      value: 'file',
      label: 'File',
    },
    {
      value: 'link',
      label: 'Url',
    },
  ];

  const handleResourceTypeSelect = (option) => {
    setNewResource({ ...newResource, type: option.value, id: getUUID() });
  };

  const handleResourceCreate = (event) => {
    handleSelected([...resources, newResource]);
    setNewResource(null);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleResourceRemove = (resource) => {
    const cleaned = resources.filter((selectedResource) => selectedResource.id !== resource.id);
    handleSelected(cleaned);
  };

  return (
    <>
      <Select
        dataDurableId="playbookResourcesListSelectId"
        label="Choose a new Resource Type"
        options={resourceTypes}
        placeholder="- TYPE -"
        onChange={handleResourceTypeSelect}
      />
      {newResource && newResource.type && (
        <form className="my-2" onSubmit={handleResourceCreate}>
          <Input
            label="Title"
            className="mb-2"
            placeholder="title"
            onChangeText={(t) => {
              setNewResource({ ...newResource, title: t });
            }}
          />
          {newResource.type === 'link' ? (
            <Input
              label="Url"
              className="mb-2"
              placeholder="https://example-resource.com"
              onChangeText={(t) => {
                setNewResource({ ...newResource, url: t });
              }}
            />
          ) : (
            <CloudinaryImageUploader
              handleImgSelect={(imgUrl) => {
                setNewResource({ ...newResource, url: imgUrl });
              }}
            />
          )}
          <Button
            className="justify-self-end"
            dataDurableId="playbookResourcesCreateButton"
            noBubble
            text="Create"
            type="primary"
            role="button"
          />
        </form>
      )}
      {resources &&
        resources.map((resource, i) => (
          <Card className="my-2" elevation={2} key={i}>
            <div className="items-center flex flex-row justify-between mb-2">
              <Typography
                className="flex items-center rounded-md px-4 py-1 text-blue border border-blue w-24 justify-center"
                variant="xs"
              >
                {resource.type}
              </Typography>
              <Icon name={resource.type} size={18} className="text-blue" />
            </div>
            <Typography className="mb-4" variant="h5">
              <a
                data-durable-id="typographyLinkId"
                data-intercom-target="typographyLinkId"
                href={resource.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {resource.title}
              </a>
            </Typography>
            {resource?.id && (
              <Button
                onClick={() => handleResourceRemove(resource)}
                dataDurableId="playbookResourcesDeleteButton"
                size="xs"
                type="destruction"
                text="Delete"
              />
            )}
          </Card>
        ))}
    </>
  );
}

export default PlaybookResourcesList;
